import React from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Grid, List, ChevronDown } from "lucide-react";
import { cn } from "@/components/utils/utils";

export type ViewMode = 'grid' | 'list';

interface ViewTravelRequestButtonProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  disabled?: boolean;
}

export const ViewTravelRequestButton: React.FC<ViewTravelRequestButtonProps> = ({
  viewMode,
  onViewModeChange,
  disabled = false,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button 
          variant="outline" 
          size="sm" 
          className="flex items-center gap-1 sm:gap-2"
          disabled={disabled}
        >
          <Grid className="h-4 w-4" />
          <span className="hidden sm:inline">View</span>
          <ChevronDown className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() => onViewModeChange('grid')}
          className={cn(viewMode === 'grid' && "bg-accent")}
        >
          <Grid className="h-4 w-4 mr-2" />
          Grid
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => onViewModeChange('list')}
          className={cn(viewMode === 'list' && "bg-accent")}
        >
          <List className="h-4 w-4 mr-2" />
          List
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
